module.exports = __webpack_public_path__ + "img/interact-resukt_one_new.af61fa64.png";